var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isSuccess && !_vm.isStarted && _vm.canStart
    ? _c("HKLLeftRight", {
        scopedSlots: _vm._u(
          [
            {
              key: "right",
              fn: function () {
                return [
                  _c(
                    "HKLButton",
                    { attrs: { color: "orange" }, on: { click: _vm.start } },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$t("tenancy.greenOperation.start")) +
                          "\n    "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          173367727
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }